// import './common';
import './blocks/dj-products-head';
import './blocks/dj-products-list';

document.querySelectorAll(".heart").forEach((heart) => {
  let isSelected = false;

  heart.addEventListener("click", () => {
    const color = isSelected ? "#CDCCCC" : "#FF0000";
    heart.setAttribute("fill", color);
    isSelected = !isSelected;
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const mediaQuery = window.matchMedia("(min-width: 450px)");

  const toggleShirtHoverEffect = () => {
    document.querySelectorAll(".product_card").forEach((shirt) => {
      const sizes = shirt.querySelector(".size-container");
      if (mediaQuery.matches) {
        shirt.onmouseover = () => (sizes.style.visibility = "visible");
        shirt.onmouseout = () => (sizes.style.visibility = "hidden");
      } else {
        sizes.style.visibility = "hidden";
        shirt.onmouseover = shirt.onmouseout = null;
      }
    });
  };

  toggleShirtHoverEffect();
  mediaQuery.addEventListener("change", toggleShirtHoverEffect);
});
